import { render, staticRenderFns } from "./AppModals.vue?vue&type=template&id=600e2aec&lang=pug&"
import script from "./AppModals.vue?vue&type=script&lang=ts&"
export * from "./AppModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports